import { PlayMode } from '../../lottie-animation/lottie-animation.esm.js';

/**
 * We did not have time to refactor the lottie animation component to accept
 * a media object, so we have to convert the media object to a lottie object
 * for the time being.
 */ const convertMediaToLottie = (props)=>{
    return {
        src: props.media?.url || '',
        playMode: PlayMode.Auto,
        loop: true,
        width: props.media?.width,
        height: props.media?.height
    };
};

export { convertMediaToLottie };
